<template>
  <v-container class="text-center fill-height d-flex flex-column justify-center align-center">
    <v-fade-transition leave-absolute>
      <div v-if="!loading && !finished" key="start">
        <v-icon size="100" color="success">mdi-auto-fix</v-icon>
        <h1 class="text-h4 font-weight-bold my-4">Bereit für die Magie?</h1>
        <p class="text-h6 font-weight-light" style="max-width: 600px">
          Der Assistent wird nun den optimalen Einsatzplan erstellen. Dabei werden Schichten generiert und Mitarbeiter fair zugewiesen.
        </p>

        <v-row justify="center" class="mt-6">
          <v-col cols="12" md="10">
            <v-card outlined class="pa-4 rounded-lg" style="background-color: rgba(255, 255, 255, 0.05)">
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold mb-2">Der Algorithmus prüft:</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-icon small color="primary" class="mr-2">mdi-account-clock</v-icon>
                    Ausgleich von Über- & Minusstunden
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <v-icon small color="primary" class="mr-2">mdi-calendar-check</v-icon>
                    Berücksichtigung von Ferien, Schultagen & fixen Abwesenheiten
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <v-icon small color="primary" class="mr-2">mdi-gavel</v-icon>
                    Einhaltung der gesetzlichen Ruhezeiten (CH)
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <v-icon small color="primary" class="mr-2">mdi-scale-balance</v-icon>
                    Faire Verteilung von Wochenend- & Abendschichten
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>

        <v-btn x-large color="success" class="mt-8" @click="$emit('trigger-assignment')">
          <v-icon left>mdi-play-circle</v-icon>
          Plan jetzt automatisch erstellen
        </v-btn>
      </div>

      <div v-else-if="loading" key="loading" class="d-flex flex-column align-center">
        <v-progress-circular :size="100" :width="8" color="primary" indeterminate></v-progress-circular>
        <h2 class="text-h5 font-weight-light mt-6">{{ currentStatus }}</h2>
        <p class="mt-2 grey--text">Dieser Vorgang kann einen Moment dauern...</p>
      </div>

      <div v-else-if="finished" key="done">
        <v-icon size="100" color="primary">mdi-check-decagram</v-icon>
        <h1 class="text-h4 font-weight-bold my-4">Einsatzplan erfolgreich erstellt!</h1>
        <p class="text-h6 font-weight-light">Der Plan wurde generiert und Mitarbeiter zugewiesen.</p>
        <v-btn x-large color="primary" class="mt-6" @click="$emit('view-plan')">
          <v-icon left>mdi-calendar-search</v-icon>
          Fertigen Plan ansehen
        </v-btn>
      </div>
    </v-fade-transition>
  </v-container>
</template>

<script>
export default {
  name: "ShiftManagementAssignment",
  props: {
    // Wir bekommen den Status jetzt vom Parent
    loading: { type: Boolean, default: false },
    finished: { type: Boolean, default: false },
  },
  data() {
    return {
      currentStatus: "Initialisiere Planung...",
      statusInterval: null,
      statuses: [
        "Sammle Mitarbeiterdaten & Regeln...",
        "Generiere Schichtbedarf...", // Neu
        "Prüfe Ferien & Abwesenheiten...",
        "Optimiere Stundensaldi...",
        "Stelle faire Verteilung sicher...",
        "Finalisiere Zuweisungen...",
      ],
    }
  },
  watch: {
    // Sobald Loading startet, starte die Animation
    loading(val) {
      if (val) {
        this.startAssignmentAnimation()
      } else {
        clearInterval(this.statusInterval)
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.statusInterval)
  },
  methods: {
    startAssignmentAnimation() {
      let index = 0
      this.currentStatus = this.statuses[0]
      this.statusInterval = setInterval(() => {
        index = (index + 1) % this.statuses.length
        this.currentStatus = this.statuses[index]
      }, 2500)
    },
  },
}
</script>

<style scoped>
.container {
  background: #1e1e1e; /* Dunkler Hintergrund für Kontrast */
}
</style>
